import { render, staticRenderFns } from "./DtInput.vue?vue&type=template&id=01f24d28&scoped=true&"
import script from "./DtInput.vue?vue&type=script&lang=ts&"
export * from "./DtInput.vue?vue&type=script&lang=ts&"
import style0 from "./DtInput.vue?vue&type=style&index=0&id=01f24d28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f24d28",
  null
  
)

export default component.exports